<template>
	<div class="styleConfig" v-loading="isDisabled">
		<div class="icon">
			<div class="icon_body">
				<span class="icon_title">展开图标：</span>
				<uploadIcon
					v-model="expandLinkValue"
					:round="true"
					:isIcon="true"
					@goLoading="setLoading"
					@change="infoChange"
				></uploadIcon>
			</div>
			<div class="icon_body">
				<span class="icon_title">关闭图标：</span>
				<uploadIcon
					v-model="closeLinkValue"
					:round="true"
					:isIcon="true"
					@goLoading="setLoading"
					@change="infoChange"
				></uploadIcon>
			</div>
		</div>

		<div class="color">
			<span class="color_title">颜色：</span>
			<el-radio-group v-model="colourTypeValue" @change="infoChange">
				<el-radio :label="1">使用主题色</el-radio>
				<el-radio :label="2">
					<div class="custom_color">
						<span>自定义颜色</span>
					</div>
				</el-radio>
			</el-radio-group>
			<el-input placeholder="请输入内容" v-model="colourValue" @change="infoChange">
				<template slot="append">
					<el-color-picker v-model="colourValue" @change="infoChange"></el-color-picker>
				</template>
			</el-input>
		</div>

		<div class="launched">
			<span class="launched_title">默认展开：</span>
			<el-switch
				v-model="expandFlagValue"
				:active-value="1"
				:inactive-value="0"
				@change="infoChange"
			>
			</el-switch>
		</div>

		<div class="suspended">
			<div class="suspended_title">鼠标悬浮提示文本：</div>
			<el-input
				v-model="floatingTipsValue"
				placeholder="请输入内容"
				maxlength="200"
				@change="infoChange"
			></el-input>
		</div>

		<div class="guide">
			<div class="guide_title">引导点击提示文本：</div>
			<el-input
				v-model="bootTipsValue"
				placeholder="请输入内容"
				maxlength="200"
				@change="infoChange"
			></el-input>
		</div>
	</div>
</template>

<script>
import uploadIcon from './component/uploadIcon.vue';

export default {
	name: 'styleConfig',
	props: [
		'bootTips',
		'closeLink',
		'colour',
		'colourType',
		'expandFlag',
		'expandLink',
		'floatingTips',
	],
	components: {
		uploadIcon,
	},
	data() {
		return {
			isDisabled: false,
			bootTipsValue: '',
			closeLinkValue: '',
			colourValue: '',
			colourTypeValue: '',
			expandFlagValue: '',
			expandLinkValue: '',
			floatingTipsValue: '',
		};
	},
	watch: {
		bootTips: {
			handler(val) {
				return (this.bootTipsValue = val);
			},
			immediate: true,
		},
		closeLink: {
			handler(val) {
				return (this.closeLinkValue = val);
			},
			immediate: true,
		},
		colour: {
			handler(val) {
				return (this.colourValue = val);
			},
			immediate: true,
		},
		colourType: {
			handler(val) {
				return (this.colourTypeValue = val);
			},
			immediate: true,
		},
		expandFlag: {
			handler(val) {
				return (this.expandFlagValue = val);
			},
			immediate: true,
		},
		expandLink: {
			handler(val) {
				return (this.expandLinkValue = val);
			},
			immediate: true,
		},
		floatingTips: {
			handler(val) {
				return (this.floatingTipsValue = val);
			},
			immediate: true,
		},
	},
	methods: {
		// 数据变化
		infoChange() {
			this.isDisabled = true;
			let {
				bootTipsValue: bootTips,
				closeLinkValue: closeLink,
				colourValue: colour,
				colourTypeValue: colourType,
				expandFlagValue: expandFlag,
				expandLinkValue: expandLink,
				floatingTipsValue: floatingTips,
			} = this;
			this.$emit(
				'changebasic',
				{ bootTips, closeLink, colour, colourType, expandFlag, expandLink, floatingTips },
				() => {
					this.isDisabled = false;
				}
			);
		},
		// 文件上传触发加载
		setLoading() {
			this.isDisabled = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.styleConfig {
	margin-top: 20px;

	.icon {
		display: flex;

		.icon_body {
			display: flex;
			align-items: center;

			.icon_title {
				font-weight: 400;
				font-size: 14px;
				color: #333333;
				margin-right: 10px;
			}
		}

		.icon_body:first-child {
			margin-right: 50px;
		}
	}

	.color {
		display: flex;
		align-items: center;
		margin-top: 20px;

		.color_title {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			margin-right: 10px;
		}

		::v-deep .el-radio-group {
			display: flex;
			align-items: center;

			.el-radio {
				display: flex;
				align-items: center;

				.custom_color {
					display: flex;
					align-items: center;
				}
			}
		}

		::v-deep .el-input {
			margin-left: 10px;
			display: flex;
			align-items: center;
			width: auto;

			.el-input__inner {
				width: 190px;
			}

			.el-input-group__append {
				width: 40px;
				height: 40px;
				padding: 0px;
				border: none;

				.el-color-picker {
					display: block;
					width: 100%;
					height: 100%;

					.el-color-picker__trigger {
						width: 100% !important;
						height: 100%;
						border-top-left-radius: 0;
						border-bottom-left-radius: 0;
						border-left: none;
					}
				}
			}
		}
	}

	.launched {
		display: flex;
		align-items: center;
		margin-top: 20px;

		.launched_title {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			margin-right: 10px;
		}
	}

	.suspended {
		margin-top: 20px;

		.suspended_title {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			margin-bottom: 10px;
		}

		.el-input {
			width: 50%;
		}
	}

	.guide {
		margin-top: 20px;

		.guide_title {
			font-weight: 400;
			font-size: 14px;
			color: #333333;
			margin-bottom: 10px;
		}

		.el-input {
			width: 50%;
		}
	}
}
</style>
